import { render, staticRenderFns } from "./BetgameInfo.vue?vue&type=template&id=30d6479e&scoped=true"
import script from "./BetgameInfo.vue?vue&type=script&lang=js"
export * from "./BetgameInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6479e",
  null
  
)

export default component.exports